import type {
  ILineConfigItem,
  IScatterConfigItem,
  ITreeMapConfigItem,
} from '../types';
import { GraphAxiesEnum } from '../types/enums';
import type {
  ILineItemData,
  ISoiScatterItem,
  ISopScatterItem,
} from '../types/response-types';

const fixValue = (num: number) => +num.toFixed(1);

export const soiToScatterConfig = ({
  brand,
  soi,
  position,
  products,
  squareValue,
}: ISoiScatterItem): IScatterConfigItem => ({
  name: brand,
  value: [fixValue(soi * 100), fixValue(position)],
  symbolSize: fixValue(squareValue ?? products),
  originalSymbolSize: fixValue(products),
});

export const sopToScatterConfig = ({
  brand,
  sos,
  position,
  positions,
  squareValue,
}: ISopScatterItem): IScatterConfigItem => ({
  name: brand,
  value: [fixValue(sos * 100), fixValue(position)],
  symbolSize: fixValue(squareValue ?? positions),
  originalSymbolSize: fixValue(positions),
});

export const lineConfigToChartItem = (
  {
    date,
    brand,
    SoI,
    SoP,
    ['average_position' as GraphAxiesEnum.averagePositon]: averagePosition,
  }: ILineItemData,
  key: string
): ILineConfigItem => {
  const mapper = {
    SoI: fixValue(SoI * 100),
    SoP: fixValue(SoP * 100),
    [GraphAxiesEnum.averagePositon]: fixValue(averagePosition),
  };

  return {
    brand,
    date,
    yValue: mapper[key as keyof typeof mapper],
  };
};

export const soiToTreeMapConfig = ({
  brand,
  soi,
}: // position,
// product_count,
ISoiScatterItem): ITreeMapConfigItem => ({
  name: brand,
  sizeValue: fixValue(soi * 100),
  colorValue: fixValue(soi * 100),
});

export const sopToTreeMapConfig = ({
  brand,
  sos,
}: // position,
// positions,
ISopScatterItem): ITreeMapConfigItem => ({
  name: brand,
  sizeValue: fixValue(sos * 100),
  colorValue: fixValue(sos * 100),
});
